import { MutableRefObject, useEffect, useRef, useState } from 'react';

export interface VideoSize {
  width: number;
  height: number;
}

type UseVideoSizeApi = [MutableRefObject<HTMLVideoElement | null>, VideoSize | null];

// adopted from : https://legacy.reactjs.org/docs/hooks-faq.html#how-can-i-measure-a-dom-node
// This is the official way to "listen" to values of a DOM Ref with useState
export const useVideoSize = (): UseVideoSizeApi => {
  const ref = useRef<HTMLVideoElement | null>(null);
  const [size, setSize] = useState<VideoSize | null>(null);

  const updateRect = () => {
    setSize({
      width: (ref.current?.videoWidth as number | undefined) || 0,
      height: (ref.current?.videoHeight as number | undefined) || 0,
    });
    if (ref.current) {
      ref.current!.onplaying = () => {
        setSize({
          width: (ref.current?.videoWidth as number | undefined) || 0,
          height: (ref.current?.videoHeight as number | undefined) || 0,
        });
      };
    }
  };

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    updateRect();
    window.addEventListener('resize', updateRect);
    return () => window.removeEventListener('resize', updateRect);
  }, []);

  return [ref, size];
};
